import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Button from '@vtex/styleguide/lib/Button'
import Price from '@/checkout-instore-legacy/components/Commons/Price'
import Box from '../../../components/Commons/Elements/Box'
import { convertChosenSkuProductsToItems } from '../../utils'

import Items from './Items'

const LastCart = ({ profile, addLastCartProductsToCart }) => {
  const hasProducts = !!(
    profile.lastCart &&
    profile.lastCart.products &&
    profile.lastCart.products.length > 0
  )

  if (!hasProducts) return null

  return (
    <Box i18nTitleId="customerProfileLastCartSectionTitle">
      <div className="flex justify-between c-on-base t-heading-6">
        <FormattedMessage
          id="orderQuantityOfItems"
          values={{ numberOfItems: profile.lastCart.products.length }}
        />
        {profile.lastCartAmount && (
          <span className="b">
            <Price value={profile.lastCartAmount.data} />
          </span>
        )}
      </div>
      <div className="nh5">
        <Items
          items={convertChosenSkuProductsToItems(profile.lastCart.products)}
        />
      </div>
      <Button
        variation="secondary"
        onClick={() => addLastCartProductsToCart(profile.lastCart.products)}
      >
        <FormattedMessage id="customerProfileRecoverOrder" />
      </Button>
    </Box>
  )
}

LastCart.propTypes = {
  profile: PropTypes.object,
  addLastCartProductsToCart: PropTypes.func,
}

export default LastCart
